import en from './en'
import de from './de'
import esUS from './esUS'
import frCA from './frCA'

export default {
  en,
  de,
  'es-US': esUS,
  'fr-CA': frCA
}
